/**
 * Webhook Actions
 * NgRx actions for webhook state management
 */
import { createAction, props } from '@ngrx/store';
import {
  Webhook,
  WebhookDelivery,
  CreateWebhookRequest,
  UpdateWebhookRequest,
  TestWebhookRequest,
  CreateWebhookResponse,
  TestWebhookResponse,
  WebhookDeliveryStatus
} from '../models/webhook.models';

/**
 * Load Webhooks
 */
export const loadWebhooks = createAction(
  '[Webhooks] Load Webhooks',
  props<{ page?: number; pageSize?: number; isActive?: boolean }>()
);

export const loadWebhooksSuccess = createAction(
  '[Webhooks] Load Webhooks Success',
  props<{ webhooks: Webhook[]; total: number; page: number; pageSize: number }>()
);

export const loadWebhooksFailure = createAction(
  '[Webhooks] Load Webhooks Failure',
  props<{ error: string }>()
);

/**
 * Load Single Webhook
 */
export const loadWebhook = createAction(
  '[Webhooks] Load Webhook',
  props<{ webhookId: string }>()
);

export const loadWebhookSuccess = createAction(
  '[Webhooks] Load Webhook Success',
  props<{ webhook: Webhook }>()
);

export const loadWebhookFailure = createAction(
  '[Webhooks] Load Webhook Failure',
  props<{ error: string }>()
);

/**
 * Create Webhook
 */
export const createWebhook = createAction(
  '[Webhooks] Create Webhook',
  props<{ request: CreateWebhookRequest }>()
);

export const createWebhookSuccess = createAction(
  '[Webhooks] Create Webhook Success',
  props<{ response: CreateWebhookResponse }>()
);

export const createWebhookFailure = createAction(
  '[Webhooks] Create Webhook Failure',
  props<{ error: string }>()
);

/**
 * Update Webhook
 */
export const updateWebhook = createAction(
  '[Webhooks] Update Webhook',
  props<{ webhookId: string; request: UpdateWebhookRequest }>()
);

export const updateWebhookSuccess = createAction(
  '[Webhooks] Update Webhook Success',
  props<{ webhook: Webhook }>()
);

export const updateWebhookFailure = createAction(
  '[Webhooks] Update Webhook Failure',
  props<{ error: string }>()
);

/**
 * Delete Webhook
 */
export const deleteWebhook = createAction(
  '[Webhooks] Delete Webhook',
  props<{ webhookId: string }>()
);

export const deleteWebhookSuccess = createAction(
  '[Webhooks] Delete Webhook Success',
  props<{ webhookId: string }>()
);

export const deleteWebhookFailure = createAction(
  '[Webhooks] Delete Webhook Failure',
  props<{ error: string }>()
);

/**
 * Test Webhook
 */
export const testWebhook = createAction(
  '[Webhooks] Test Webhook',
  props<{ webhookId: string; request: TestWebhookRequest }>()
);

export const testWebhookSuccess = createAction(
  '[Webhooks] Test Webhook Success',
  props<{ response: TestWebhookResponse }>()
);

export const testWebhookFailure = createAction(
  '[Webhooks] Test Webhook Failure',
  props<{ error: string }>()
);

/**
 * Load Webhook Deliveries
 */
export const loadWebhookDeliveries = createAction(
  '[Webhooks] Load Webhook Deliveries',
  props<{ webhookId: string; page?: number; pageSize?: number; status?: WebhookDeliveryStatus }>()
);

export const loadWebhookDeliveriesSuccess = createAction(
  '[Webhooks] Load Webhook Deliveries Success',
  props<{ deliveries: WebhookDelivery[]; total: number; page: number; pageSize: number }>()
);

export const loadWebhookDeliveriesFailure = createAction(
  '[Webhooks] Load Webhook Deliveries Failure',
  props<{ error: string }>()
);

/**
 * Clear Webhook Secret (after user has saved it)
 */
export const clearWebhookSecret = createAction(
  '[Webhooks] Clear Webhook Secret'
);

/**
 * Clear Test Result
 */
export const clearTestResult = createAction(
  '[Webhooks] Clear Test Result'
);

